export const RoutesFormDataObject = {
    location: '',
    language: '0'
}